import { render, staticRenderFns } from "./DaReplicaDialog.vue?vue&type=template&id=2d74d279"
import script from "./DaReplicaDialog.vue?vue&type=script&lang=js"
export * from "./DaReplicaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports